window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.ADD_TO_CART,
    function (data) {
        console.log("ADD_TO_CART", data);
        const formData = new FormData();
        let variant_id = data.id;
        formData.append("id", variant_id);
        formData.append("quantity", "1");
        let productIndex = data.productIndex;
        
        // https://vasaindica.com/cart/add.js
        fetch("https://vasaindica.com/cart/add.js", {
        method: "POST",
        body: formData,
      }).then((data) => {
        let ATC_btn = document.querySelectorAll('#wizzy-featured-view-add-to-cart')[productIndex];
        if (ATC_btn) {
            // const originalText = ATC_btn.innerText;

            ATC_btn.innerText = "Adding...";
            ATC_btn.disabled = true;

            setTimeout(() => {
                ATC_btn.innerText = "Added!";
            }, 2000);

            setTimeout(() => {
                ATC_btn.innerText = "Add to Cart";
                ATC_btn.disabled = false;
            }, 4000);
        }
      });
        return data;
    });
    
    window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.BEFORE_PRODUCTS_FETCHED,
    function (data) {
      console.log("BEFORE_PRODUCTS_FETCHED",data);
      let filters = JSON.parse(data.filters);
        filters.swatch = [{
            key: "product_Color"
        }, {
            key: "product_Size"
        }];
        data.filters = JSON.stringify(filters);
      
      console.log("BEFORE_PRODUCTS_FETCHED===>",data);
      return data;
    }
   );
    window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      console.log("AFTER_PRODUCTS_TRANSFORMED",data);
      return data;
    }
   );
     window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.AFTER_PRODUCTS_FETCHED,
    function (data) {
        console.log("AFTER_PRODUCTS_FETCHED",data);
        return data;
    });
